<script lang="ts">
  import AlertTag from '$shared/atoms/AlertTag/AlertTag.svelte';
  import ResolvedUnknownValueType from '$shared/atoms/ResolvedUnknownValueType/ResolvedUnknownValueType.svelte';
  import Action from './Action.svelte';
  import type { ProfileMergeList } from '$provider/models/ProfileMergeList';

  const ReviewDisclaimer = `Record can't be added until it's resolved`;

  interface Props {
    item: ProfileMergeList;
    onalert?: (item: ProfileMergeList) => void;
    onresolveedit?: (item: ProfileMergeList) => void;
    onclickrecord?: (item: ProfileMergeList) => void;
    onreview?: (item: ProfileMergeList) => void;
    ontoggleadd?: (item: ProfileMergeList) => void;
  }

  let { item, onalert, onresolveedit, onclickrecord, onreview, ontoggleadd }: Props = $props();

  let clickableLabel = $derived(item?.canPreview);

  const onClickAlert = (): void => {
    onalert?.(item);
  };

  const onClickResolveEdit = (): void => {
    onresolveedit?.(item);
  };

  const onClickLabel = (): void => {
    onclickrecord?.(item);
  };
</script>

<div data-cy="merge-item" id={item.id} class="merge-i">
  <div data-cy="merge-item-row" class="merge-i-row">
    <button
      data-cy="merge-item-label"
      class="merge-i-label"
      class:clickable-label={clickableLabel}
      onclick={onClickLabel}
    >
      <span data-cy="merge-item-title" class="title">{item.title}</span>
    </button>
    <div data-cy="merge-item-action" class="merge-i-action">
      <Action {item} {onreview} {ontoggleadd} />
    </div>
  </div>
  {#if item.subLabel || item.alert?.isBadData}
    <div class="merge-i-sub-row">
      <div data-cy="merge-item-sub-label" class="sub-label">
        {item.subLabel ?? ''}
      </div>
      {#if item.alert?.isBadData}
        <div data-cy="action-disclaimer" class="disclaimer">
          {item.alert.badDataDisclaimer}
        </div>
      {/if}
    </div>
  {/if}
  {#if item.alert?.isReview}
    <div data-cy="merge-item-alert-row" class="merge-i-alert-row">
      <div class="alert">
        <AlertTag label={item.alert.parsedLabel} onclick={onClickAlert} />
      </div>
      <div data-cy="action-disclaimer" class="disclaimer">{ReviewDisclaimer}</div>
    </div>
  {:else if item.props.hasUnrecognizedRecordResolved}
    <div data-cy="resolved-unknown-item" class="resolve-unknown-license">
      <ResolvedUnknownValueType
        label={item.props.unRecognizedTypeLabel}
        onclickedit={onClickResolveEdit}
      />
    </div>
  {/if}
</div>

<style>
  .merge-i:not(:last-child) {
    padding-bottom: 16px;
  }
  .merge-i:not(:first-child) {
    padding-top: 16px;
  }
  .merge-i .merge-i-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .merge-i:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }

  .merge-i .merge-i-label {
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    pointer-events: none;
  }

  .merge-i .merge-i-label.clickable-label {
    cursor: pointer;
    pointer-events: all;
  }
  .merge-i .merge-i-sub-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-top: 2px;
  }
  .merge-i .sub-label {
    font-size: 12px;
    color: var(--grey-dark);
  }

  .merge-i .merge-i-action {
    display: inline-flex;
    justify-content: flex-end;
  }
  .disclaimer {
    display: inline-flex;
    justify-content: flex-end;
  }
  .merge-i .merge-i-alert-row {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }
  .disclaimer {
    font-size: 11px;
    color: var(--grey-medium);
    align-items: center;
    text-align: end;
  }
  .resolve-unknown-license {
    margin-top: 8px;
  }
</style>
